var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.isLoggedIn && _vm.isRegistered)?_c('LoggedIn',{attrs:{"guideStart":true}}):_c('LoggedOut')],1)}
var staticRenderFns = []

export { render, staticRenderFns }